/** Baca variabel CRA (REACT_APP_*). Kosong = gunakan fallback di mock. */

export function envString(key, fallback = "") {
  const v = process.env[key];
  if (v == null || String(v).trim() === "") return fallback;
  return String(v).trim();
}

/** Untuk URL opsional: string kosong di .env dianggap tidak diisi → null */
export function envUrl(key) {
  const v = envString(key, "");
  return v || null;
}
